const dateOptions: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
};

const dateMonthYearOptions: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'numeric',
  timeZone: 'GMT',
};

const dateTimeOptions: Intl.DateTimeFormatOptions = {
  ...dateOptions,
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric',
  hour12: false,
};

const createDate = (date?: string | Date): Date =>
  date ? new Date(date) : new Date();

export const isValidDate = (date?: string | Date): boolean =>
  date === undefined || !!new Date(date).getDate();

export const parseDateTimeToPTBR = (date?: string | Date): string =>
  isValidDate(date)
    ? new Intl.DateTimeFormat('pt-BR', dateTimeOptions).format(createDate(date))
    : '';

export const parseDateToPTBR = (date?: string | Date): string =>
  isValidDate(date)
    ? new Intl.DateTimeFormat('pt-BR', dateOptions).format(createDate(date))
    : '';

export const parseMonthYearToPTBR = (date?: string | Date): string =>
  isValidDate(date)
    ? new Intl.DateTimeFormat('pt-BR', dateMonthYearOptions).format(
        createDate(date),
      )
    : '';

export const diffenceBetweenDates = (
  date1: string | Date,
  date2: string | Date,
): number => new Date(date1).getTime() - new Date(date2).getTime();

export const isBefore = (date1: string | Date, date2: string | Date): boolean =>
  new Date(date1).getTime() < new Date(date2).getTime();

export const isAfter = (date1: string | Date, date2: string | Date): boolean =>
  new Date(date1).getTime() > new Date(date2).getTime();

export const isBeforeNow = (date: string | Date): boolean =>
  new Date(date).getTime() < new Date().getTime();

export const isAfterNow = (date: string | Date): boolean =>
  new Date(date).getTime() > new Date().getTime();
